module.exports = __webpack_public_path__ + "static/media/img_dance06.9b334b51.png";